import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const CopyrightIcon: LucideIcon = forwardRef(({ size = 34, color = 'black', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 34 34'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M21.245 21.245C20.4056 22.0834 19.3365 22.6542 18.1728 22.8852C17.0091 23.1162 15.803 22.997 14.7071 22.5426C13.6111 22.0883 12.6744 21.3193 12.0154 20.3327C11.3564 19.3462 11.0047 18.1864 11.0047 17C11.0047 15.8136 11.3564 14.6538 12.0154 13.6673C12.6744 12.6807 13.6111 11.9117 14.7071 11.4574C15.803 11.003 17.0091 10.8838 18.1728 11.1148C19.3365 11.3458 20.4056 11.9166 21.245 12.755M32 17C32 25.2843 25.2843 32 17 32C8.71573 32 2 25.2843 2 17C2 8.71573 8.71573 2 17 2C25.2843 2 32 8.71573 32 17Z'
        stroke={color}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
})

CopyrightIcon.displayName = 'CopyrightIcon'
